// extracted by mini-css-extract-plugin
export default {"identity":"ITib9lyV","name":"MWr23Emw","label":"cbkndI6H","addresses":"c9Mkb17h","address":"eARjKai9","addressText":"j2O5B219","actions":"DqvcFASt","editButton":"svUWGpBD"};